<template>
  <div
    class="where_to_buy"
    :class="{ bg_gray: _.get(contentData, 'conf.conf[0]') }"
  >
    <div class="where_to_buy__ttl-wrapper container">
      <h2 class="where_to_buy__ttl f-24 bold wc-lg uppercase">
        {{ main_title }}
      </h2>
    </div>
    <div class="where_to_buy__inner container">
      <swiper :options="swiperOptions">
        <swiper-slide :key="index" v-for="(service, index) in content">
          <a target="_blank" :href="_.get(service, 'url')" class="where_to_buy__slide bg-white flex a_center br-12 wc-lg">
            <div
              class="where_to_buy__icon br-12 wc-lg"
              v-html="service.svg"
            ></div>

            <h2 class="where_to_buy__ttl f-18 bold">{{ service.title }}</h2>
          </a>
        </swiper-slide>
      </swiper>
    </div>
    <div class="where_to_buy__scrollbar flex j_sb container">
      <div class="where_to_buy__scrollbar--line"></div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 30,
        grabCursor: true,
        //    slidesOffsetBefore: 405,
        // slidesOffsetAfter: 20,
        speed: 800,
        watchOverflow: true,
        scrollbar: {
          el: ".where_to_buy__scrollbar--line",
          draggable: true,
          hide: false,
          dragSize: 350,
          snapOnRelease: false
        },
        navigation: {
          nextEl: ".where_to_buy__next",
          prevEl: ".where_to_buy__prev"
        },
        breakpoints: {
          1206: {
            slidesOffsetBefore: 47,
            slidesOffsetAfter: 47
          },
          1023: {
            spaceBetween: 30,
            slidesPerView: 1.5,
            slidesOffsetBefore: 45,
            slidesOffsetAfter: 45,
            scrollbar: {
              dragSize: 137
            }
          },
          767: {
            spaceBetween: 10,
            // slidesPerView: 1.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            scrollbar: {
              dragSize: 137
            }
          }
        },
        on: {
          touchMove() {
            if (
              document.querySelectorAll(".where_to_buy .swiper-slide").length >=
              5
            ) {
              document
                .querySelectorAll(".where_to_buy .swiper-slide")
                .forEach(slide => {
                  slide.style.transform = "scale(0.9, 0.9)";
                });
            }
          },
          touchEnd() {
            if (
              document.querySelectorAll(".where_to_buy .swiper-slide").length >=
              5
            ) {
              document
                .querySelectorAll(".where_to_buy .swiper-slide")
                .forEach(slide => {
                  slide.style.transform = "scale(1, 1)";
                });
            }
          }
        },
        pagination: {}
      }
    };
  },
  computed: {
    main_title() {
      return _.get(this.contentData, "conf.header.title");
    },
    content() {
      return _.get(this.contentData, "data.list");
    }
  },
  mounted() {},
  destroyed() {}
};
</script>
